<template>
	<div id="home" v-loading='loading'>
		<div id='homect'>
			<div id='homectl'>
				<div id='hlg'>
					<img :src="hlogo" />
				</div>
				<el-menu style="width: 100%;" :default-active="rtPath" :router='true' class="el-menu-vertical-demo"
					background-color="white" text-color="#000000" active-text-color="#1890FF">
					<span v-for='item in menus' :key='item.path'>
						<el-menu-item v-if='!item.meta.folder' :index="item.path">
							<!-- <img style="width: 14px;height: auto;" :src="micons[item.meta.icon]" /> -->
							<i :class="item.meta.icon"></i>
							<span style="" slot="title">{{item.name}}</span>
						</el-menu-item>
						<el-submenu :index="item.path" v-else>
							<template slot="title">
								<!-- <img style="width: 14px;height: 14px; margin-right:10px;" :src="micons[item.meta.icon]" /> -->
								<i :class="item.meta.icon"></i>
								<span>{{item.name}}</span>
							</template>
							<el-menu-item-group :key='sitem.path' v-for='sitem in item.children'>
								<el-menu-item style="margin-left: 10px;" :index="sitem.path">{{sitem.name}}
								</el-menu-item>
							</el-menu-item-group>
						</el-submenu>
					</span>
				</el-menu>
			</div>
			<!--
      -->
			<div id='homectr'>
				<div id='hctrtt'>
					<label style="color: #001529;margin-right: 24px;">
						<el-dropdown trigger="click" @command="handleCommand">
							<span class="el-dropdown-link">
								{{uNick}}<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="logout">{{ $t('app_sign_out') }}</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</label>
				</div>
				<router-view id='homectrct' />
			</div>
		</div>
	</div>
</template>

<script>
	// @ is an alias to /src
	// import HelloWorld from '@/components/HelloWorld.vue'
	import hlogo from '../assets/homeszzt.svg'
	export default {
		name: 'home',
		data() {
			return {
				// micons: {
				//   'home': require('@/assets/menu/home.png'),
				//   'equipment': require('@/assets/menu/equipment.png'),
				//   'merchant': require('@/assets/menu/merchant.png'),
				//   'agent': require('@/assets/menu/agent.png'),
				//   'person': require('@/assets/menu/person.png'),
				//   'config': require('@/assets/menu/config.png')
				// },
				hlogo: hlogo,
				menus: this.$router.options.routes[0].children,
				loading: false
			}
		},
		computed: {
			// routeName () {
			//   return this.$store.state.rtname
			// }
			rtPath() {
				return this.$route.path
			},
			uNick() {
				var user = this.$getTmp('user')
				return user.nickName
			}
		},
		components: {
			// HelloWorld
		},
		methods: {

			handleCommand(cm) {
				if (cm == 'logout') {
					this.$showMsgBox(this.$t('app_sign_out_message'), () => {
						this.loading = true
						this.$logout(res => {
							this.loading = false
							if (res.status == 200) {
								this.$logoutOp(this)
							} else {
								this.$message.error(res.message)
							}
						}, () => {
							this.loading = false
						})
					})
				}
			}
		},
		mounted() {
			if (!localStorage.token) {
				this.$logoutOp(this)
			}
		}
	}
</script>

<style>
	#home {
		height: 100%;
		width: 100%;
	}

	#httl {
		display: inline-block;
		width: 256px;
		height: 100%;
		text-align: center;
		overflow: hidden;
		/* box-shadow:0px 2px 6px 0px rgba(0,21,41,0.08); */
		box-shadow: 2px 0px 6px 0px rgba(29, 35, 41, 0.05);
	}

	#hlg {
		width: 100%;
		height: 65px;
		line-height: 65px;
		overflow: hidden;
		text-align: center;
		border-bottom: 1px solid rgba(232, 232, 232, 1);
	}

	#hlg img {
		display: block;
		margin: auto;
		margin-top: 21px;
		width: 181px;
	}

	#homect {
		height: 100%;
		/* background: red; */
		width: 100%;
		overflow: hidden;
	}

	#homectl {
		position: relative;
		width: 256px;
		height: 100%;
		background: white;
		display: inline-block;
		z-index: 5;
		box-shadow: 2px 0px 6px 0px rgba(29, 35, 41, 0.05);
	}

	#homectr {
		position: relative;
		float: right;
		margin-left: 0px;
		width: calc(100% - 256px);
		height: 100%;
		background: white;
		display: inline-block;
		overflow: scroll;
		background: rgb(237, 239, 242);
	}

	#homectrct {
		/* margin: 24px; */
		/* border-radius:2px; */
		/* background: none; */
		min-height: 0%;
		/* padding: 24px 32px 24px 32px;     */
	}

	#hctrtt {
		z-index: 2;
		position: relative;
		width: 100%;
		height: 64px;
		line-height: 64px;
		color: #101010;
		background: white;
		text-align: right;
		box-shadow: 0px 2px 6px 0px rgba(0, 21, 41, 0.08);
	}
</style>
